const getCarGroup = (client, id) => client.request({
  url: `/v1/application/carGroups/${id}`,
  method: 'get',
});

export default {
  getCarGroup,
};
